module.exports = __webpack_public_path__ + "img/win-win.24a231e.png";